class backgroundVideo {
  constructor(container) {
    this.element = container;
    this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
    this.loop = null;
    this.loadScripts().then(this.setupPlayer.bind(this));
  }

  loadScripts() {
    var _this = this;

    console.log('ought to load scripts');

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      document.body.appendChild(script);
      script.onload = resolve;
      script.onerror = reject;
      script.async = true;
      script.src = _this.options['videoType'] === 'youtube' ? '//www.youtube.com/iframe_api' : '//player.vimeo.com/api/player.js';
    });
  }

  onUnload() {
    if (this.player) {
      this.player.destroy(); // Both YouTube and Vimeo use the same function name
    }
  }

  setupPlayer() {
    var _this = this;

    var elementWrapper = this.element.querySelector('.hero--video');
    var elementToInsert = this.element.querySelector('.hero--video--container');

    if (_this.options['videoType'] === 'youtube') {
      var url = "https://www.youtube.com/embed/" + _this.options['videoId'];
      // var url = "https://www.youtube.com/embed/1HNCQ9K9dXk";
      $.getJSON('https://noembed.com/embed', { format: 'json', url: url }, function (data) {
        // let imgUrl = data.thumbnail_url;
        let imgUrl = 'https://img.youtube.com/vi/' + _this.options['videoId'] + '/maxres1.jpg';
        let img = new Image();
        img.className = 'lores';
        img.src = imgUrl;
        $(elementWrapper).append(img);
        $(elementWrapper).css('background-image', 'url(' + imgUrl + ')');
        _this.thumb = img;
        console.log('Dimensions: ' + data.width + 'x' + data.height);
      });
    }

    var playerLoadingInterval = setInterval(function () {
      if (_this.options['videoType'] === 'youtube') {

        if (window.YT) {
          _this.player = new YT.Player(elementToInsert, {
            videoId: _this.options['videoId'],
            playerVars: {
              showinfo: 0,
              controls: 0,
              fs: 0,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
              origin: 'https://' + _this.options['requestHost']
            },
            events: {
              onReady: _this._onYouTubeReady.bind(_this),
              onStateChange: _this._onYouTubeStateChange.bind(_this)
            }
          });

          _this._bindControls(_this);

          clearInterval(playerLoadingInterval);
        }
      } else {
        if (window.Vimeo) {
          _this.player = new Vimeo.Player(elementToInsert.parentNode, {
            id: _this.options['videoId'],
            autoplay: true,
            autopause: false,
            muted: true,
            background: true,
            /*height: '100%',
            width: '100%',*/
            loop: true
          });

          _this._bindControls(_this);

          clearInterval(playerLoadingInterval);
        }
      }
    }, 50);
  }

  _bindControls(tar) {
    console.log('binding');
    var _this = tar;
    _this.playbut = $(_this.element).find('.play--but');
    _this.bigplay = $(_this.element).find('.hero--video--bigplay');
    _this.sound = $(_this.element).find('.sound');
    _this.controls = $(_this.element).find('.hero--video--controls');
    _this.fullbut = $(_this.element).find('.full--but');
    _this.timeline = $(_this.element).find('.timeline');
    _this.timelinebar = $(_this.element).find('.timeline--bar--elapsed');

    $(_this.element).mousemove(function () {
      $(_this.controls).addClass('in');
      clearTimeout(_this.controls.timeout);
      _this.controls.timeout = setTimeout(function () {
        $(_this.controls).removeClass('in');
      }, 50);
    })

    $(_this.timeline).click(function (e) {
      e.preventDefault();
      var prc = e.offsetX / this.getBoundingClientRect().width;
      var dur = _this.player.getDuration();
      $(_this.timelinebar).width((prc * 100) + '%');
      _this.player.seekTo(dur * prc);
    }).mousemove(function (e) {
      var prc = e.offsetX / this.getBoundingClientRect().width;
      var dur = _this.player.getDuration();
      $(_this.timelinebar).width((prc * 100) + '%');
    });

    $(_this.fullbut).click(function (e) {
      e.preventDefault();
      if (!document.fullscreenElement) {
        var requestFullScreen = _this.element.requestFullScreen || _this.element.mozRequestFullScreen || _this.element.webkitRequestFullScreen;
        if (requestFullScreen) {
          requestFullScreen.bind(_this.element)();
        }
        $(this).text(window.themeStrings.close ? window.themeStrings.close : 'close');
      } else {
        document.exitFullscreen();
        $(this).text('full');
      }
    });

    $(_this.playbut).click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      var state = _this.player.getPlayerState();
      if (state === YT.PlayerState.PLAYING) {
        $(_this.element).find('iframe').addClass('out');
        $(this.playbut).text('play');
        setTimeout(function () {
          _this.player.pauseVideo();
        }, 200);
      } else if (state === YT.PlayerState.PAUSED) {
        _this.player.playVideo();
        $(this.playbut).text('pause');
        setTimeout(function () {
          $(_this.element).find('iframe').removeClass('out');
        }, 260);
      }
    });

    $(_this.bigplay).click(function (e) {
      e.stopPropagation();
      $(_this.playbut).click();
    });

    $(_this.sound).unbind('mousemove mouseleave click').mousemove(function (e) {
      e.preventDefault();
      var prc = e.offsetX / this.getBoundingClientRect().width;
      $(this).find('.sound--trigger').width(prc * 100 + '%');
      if (_this.sound.down) {
        _this.player.setVolume(prc * 100);
        if ((prc * 100) > 10) {
          _this.player.unMute();
          $(this).find('.sound--trigger').width(prc * 100 + '%').attr('data-width', prc * 100 + '%');
        } else {
          _this.player.mute();
          $(this).find('.sound--trigger').width('0%').removeAttr('data-width');
        }
      }
    }).mouseleave(function (e) {
      _this.sound.down = false;
      var attr = $(this).find('.sound--trigger').attr('data-width')
      $(this).find('.sound--trigger').width(attr || '');
    }).mouseup(function (e) {
      _this.sound.down = false;
    }).mousedown(function (e) {
      _this.sound.down = true;
    }).click(function (e) {
      e.stopPropagation();
      e.preventDefault();
      var prc = (e.offsetX / this.getBoundingClientRect().width) * 100;
      _this.player.setVolume(prc);
      if ((prc) > 10) {
        _this.player.unMute();
        $(this).find('.sound--trigger').width(prc + '%').attr('data-width', prc + '%');
      } else {
        _this.player.mute();
        $(this).find('.sound--trigger').width('0%').removeAttr('data-width');
      }
    });
  }

  _onYouTubeReady(event) {
    this.player.mute();
    this.player.playVideo();
  }

  _onYouTubeStateChange(event) {
    if (event.data === YT.PlayerState.PLAYING) {
      $(this.thumb).addClass('out');
      if (this.controls) {
        $(this.playbut).text('pause');
        this.loop = setInterval(this._youtubeUpdateLoop.bind(this), 100);
        clearTimeout(this.controls.timeout);
        $(this.controls).removeClass('in');
      }
    }
    if (event.data === YT.PlayerState.PAUSED) {
      if (this.controls) {
        $(this.playbut).text('play');
        $(this.controls).addClass('in');
        clearInterval(this.loop);
      }
    }
    if (event.data === YT.PlayerState.ENDED) {
      this.player.playVideo();
    }
  }

  _youtubeUpdateLoop() {
    var _this = this;
    var elapsed = _this.player.getCurrentTime() / _this.player.getDuration();
    // console.log(elapsed);
    if (!$(_this.timeline).is(':hover')) {
      $(_this.timelinebar).width((elapsed * 100) + '%');
    }
  }


} export default backgroundVideo;
